import React, { useState } from "react";
import { FaUser } from "react-icons/fa6";
import { GiProgression } from "react-icons/gi";
import { IoMdSettings } from "react-icons/io";
import {
  MdCreditScore,
  MdSpaceDashboard,
  MdSupportAgent,
  MdVideoLibrary,
} from "react-icons/md";
import { PiCreditCardFill } from "react-icons/pi";

import { Link } from "react-router-dom";
import "./layout.css";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  // Correctly destructure menuItems and setMenuItems
  const [menuItems, setMenuItems] = useState([
    {
      id: 1,
      label: "Dashboard",
      icon: <MdSpaceDashboard className="icons" />,
      isActive: true,
      route: "/dashboard",
    },
    {
      id: 2,
      label: "Your Progress",
      icon: <GiProgression className="icons" />,
      isActive: false,
      route: "/your-progress",
    },
    {
      id: 3,
      label: "Repair Credit",
      icon: <MdCreditScore className="icons" />,
      isActive: false,
      route: "/repair-credit",
    },
    {
      id: 4,
      label: "Tutorials",
      icon: <MdVideoLibrary className="icons" />,
      isActive: false,
      route: "/tutorials",
    },
    {
      id: 5,
      label: "Funding",
      icon: <PiCreditCardFill className="icons" />,
      isActive: false,
      route: "/funding",
    },
    {
      id: 6,
      label: "Invest",
      icon: <PiCreditCardFill className="icons" />,
      isActive: false,
      route: "/invest",
    },
    {
      id: 8,
      label: "Help Center",
      icon: <MdSupportAgent className="icons" />,
      isActive: false,
      route: "/help-center",
    },
    {
      id: 9,
      label: "Clients Dashboard",
      icon: <FaUser className="icons" />,
      isActive: false,
      route: "/clients-dashboard",
    },
    {
      id: 10,
      label: "Repair Their Credit",
      icon: <IoMdSettings className="icons" />,
      isActive: false,
      route: "/repair-their-credit",
    },
    {
      id: 11,
      label: "Profile",
      icon: <IoMdSettings className="icons" />,
      isActive: false,
      route: "/profile",
    },
  ]);

  // Split menu items into two arrays
  const firstMenuItems = menuItems.slice(0, 6);
  const secondMenuItems = menuItems.slice(6);

  const setActiveItem = (id) => {
    const updatedItems = menuItems.map((item) => ({
      ...item,
      isActive: item.id === id,
    }));
    setMenuItems(updatedItems);

    // Close sidebar on mobile and add 'sider-collapsed' class
    if (window.innerWidth <= 1200) {
      toggleSidebar();
    }
  };

  return (
    <div className={`side_navbar ${isOpen ? "" : "sider-collapsed"}`}>
      <div className="main_menu_area">
        <ul className="side_nav_menu">
          {firstMenuItems.map((item) => (
            <li
              key={item.id}
              className={`side_nav_list ${item.isActive ? "active" : ""}`}
              onClick={() => setActiveItem(item.id)}
            >
              <Link to={item.route} className="nav-link">
                {item.icon}
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <ul className="side_nav_menu">
          <h3>Business</h3>
          {secondMenuItems.map((item) => (
            <li
              key={item.id}
              className={`side_nav_list ${item.isActive ? "active" : ""}`}
              onClick={() => setActiveItem(item.id)}
            >
              <Link to={item.route} className="nav-link">
                {item.icon}
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
